const orderDetailsConstants = {
  SET_SELECTED_ROUTE_STOP_SUCCESS: 'SET_SELECTED_ROUTE_STOP_SUCCESS',
  SET_ORDER_DETAILS_GRID_FILTER: 'SET_ORDER_DETAILS_GRID_FILTER',
  SET_ORDER_DETAILS_GRID_FILTERS: 'SET_ORDER_DETAILS_GRID_FILTERS',
};

export default orderDetailsConstants;
